import type {ExtractPropsWithoutRef} from '@/types';

import styled from '@emotion/styled';
import {IconClose} from '@travel-frontend/icons';
import {IconButton} from '@travel-frontend/ui-components';

export const CloseButton = styled(
  (props: ExtractPropsWithoutRef<typeof IconButton>) => (
    <IconButton category="tertiary" round {...props}>
      <IconClose />
    </IconButton>
  )
)``;
